import React from 'react';
import { ResponsiveGrid } from '@alifd/next';
import PageHeader from '@/components/PageHeader';
import ResidentBaAuthList from './components/ResidentBaAuthList';

const { Cell } = ResponsiveGrid;

const ResidentBaAuth = () => (
  <ResponsiveGrid gap={20}>
    <Cell colSpan={12}>
      <PageHeader
        title="門禁權限管理"
        // description="住戶建立棟別"
        breadcrumbs={[
          {
            name: 'BA系統',
          },
          {
            name: '門禁權限管理',
          },
        ]}
      />
    </Cell>

    <Cell colSpan={12}>
      <ResidentBaAuthList />
    </Cell>
  </ResponsiveGrid>
);

export default ResidentBaAuth;
